import React from 'react';
import BikinisImage from './images/bikinis-image.png';
import GownsImage from './images/gowns-image.png';
import HeelsImage from './images/heels-image.png';
import PhotoshootImage from './images/photoshoot-image.png';
import css from './SectionCategories.module.css';
import { NamedLink } from '../../../../components';

const SectionCategories = () => {

  return (
    <div className={css.wrapper}>

      <NamedLink
        name="SearchPage" to={{ search: '?pub_category=Couture-Bikinis' }}>
        <div className={css.categoryContainer}>
          <img className={css.categoryImage} src={BikinisImage} />
          <p className={css.categoryName}>
            Bikinis
          </p>
        </div>
      </NamedLink>

      <NamedLink
        name="SearchPage" to={{ search: '?pub_category=Gowns' }}>
        <div className={css.categoryContainer}>
          <img className={css.categoryImage} src={GownsImage} />
          <p className={css.categoryName}>
            Gowns
          </p>
        </div>
      </NamedLink>

      <NamedLink
        name="SearchPage" to={{ search: '?pub_category=Heels' }}>
        <div className={css.categoryContainer}>
          <img className={css.categoryImage} src={HeelsImage} />
          <p className={css.categoryName}>
            Heels
          </p>
        </div>
      </NamedLink>

      <NamedLink
        name="SearchPage" to={{ search: '?pub_category=Photoshoot-outfits-accessories' }}>
        <div className={css.categoryContainer}>
          <img className={css.categoryImage} src={PhotoshootImage} />
          <p className={css.categoryName}>
            Photoshoot outfits & accesories
          </p>
        </div>
      </NamedLink>

    </div >
  );
};

export default SectionCategories;
